import React from 'react';
import { T } from 'shared/helper/translate';
import SavedAddressForm from './SavedAddressFormContainer';
import Address from './Address';
var SavedAddresses = function SavedAddresses(_ref) {
  var address = _ref.address,
    addresses = _ref.addresses,
    countries = _ref.countries,
    deleteAddress = _ref.deleteAddress,
    match = _ref.match,
    updateAddress = _ref.updateAddress;
  if (address) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-md-8 saved-addresses"
    }, /*#__PURE__*/React.createElement(SavedAddressForm, {
      match: match,
      updateAddress: updateAddress
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 saved-addresses"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(T, {
    source: "Saved addresses"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, addresses.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-light alert p-4 text-muted text-center"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "no-saved-addresses"
  }))) : addresses.map(function (address) {
    return /*#__PURE__*/React.createElement(Address, {
      address: address,
      countries: countries,
      deleteAddress: deleteAddress,
      key: address.id
    });
  })));
};
export default SavedAddresses;